exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Logo__root--HMg9n{-webkit-transition:all .2s ease-in-out;transition:all .2s ease-in-out;height:40px}@media (max-width:1024px){.Logo__root--HMg9n{height:21px}}@media (min-width:1025px){.Logo__compressed--1HrUV{-webkit-transition:all .2s ease-in-out;transition:all .2s ease-in-out;height:25px}}", ""]);

// exports
exports.locals = {
	"root": "Logo__root--HMg9n",
	"compressed": "Logo__compressed--1HrUV"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]"}!./node_modules/postcss-loader/lib?{"sourceMap":false}!./src/components/Library/Logo/Logo.css
// module id = ./node_modules/css-loader/index.js?{"sourceMap":false,"minimize":true,"modules":true,"localIdentName":"[name]__[local]--[hash:base64:5]"}!./node_modules/postcss-loader/lib/index.js?{"sourceMap":false}!./src/components/Library/Logo/Logo.css
// module chunks = 1